/* IJC Product Page — gallery, variants, quantity, accordions, help, share */
(function() {
  var C = window.IJC_CONFIG || {};
  var I = document.getElementById.bind(document);
  var Q = document.querySelectorAll.bind(document);
  var G = null;
  var variants = C.variants || [];
  var currentVariantId = C.currentVariantId;
  var currencyCode = C.currencyCode || 'USD';
  var optionCount = C.optionCount || 1;

  /* Prefer the shop's own money format (snippets/money-js.liquid) so a price repainted on a
     variant change is identical to the one Liquid rendered. Intl is only the fallback: it
     formats for the VISITOR's locale, which can disagree with the shop on the separator and
     even on which side the currency symbol sits. */
  function formatMoney(cents) {
    if (window.SheodraMoney) return window.SheodraMoney.format(cents);
    try {
      var needsCode = (currencyCode === 'CAD' || currencyCode === 'AUD');
      var formatted = new Intl.NumberFormat(undefined, {
        style: 'currency', currency: needsCode ? 'USD' : currencyCode,
        minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: false
      }).format(Math.round(cents / 100));
      if (needsCode) formatted = currencyCode + ' ' + formatted;
      return formatted;
    } catch(e) { return currencyCode + ' ' + Math.round(cents / 100); }
  }

  function getDeliveryDate(workingDays) {
    var days = (typeof workingDays === 'number' && workingDays > 0) ? workingDays : 7;
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    var suffix = 'th';
    var dd = d.getDate();
    if (dd === 1 || dd === 21 || dd === 31) suffix = 'st';
    else if (dd === 2 || dd === 22) suffix = 'nd';
    else if (dd === 3 || dd === 23) suffix = 'rd';
    return dd + suffix + ' ' + months[d.getMonth()];
  }

  function setDeliveryDates() {
    var workingDays = C.deliveryWorkingDays || 7;
    var dateStr = getDeliveryDate(workingDays);
    var el1 = I('ijcDeliveryDate');
    var el2 = I('ijcDeliveryDate2');
    if (el1) el1.textContent = dateStr;
    if (el2) el2.textContent = dateStr;
  }

  function initGallery() {
    var thumbs = Q('.ijc-product__gallery-thumb');
    var mainMedia = I('ijcMainMedia');
    var currentIndex = 0;
    /* Start on whichever thumb the server marked active — it matches the selected variant's
       image (see product2.liquid), so prev/next and the highlight stay in sync on load. */
    for (var _ai = 0; _ai < thumbs.length; _ai++) {
      if (thumbs[_ai].classList.contains('ijc-product__gallery-thumb--active')) { currentIndex = _ai; break; }
    }
    var totalSlides = thumbs.length;

    if (totalSlides === 0) return;

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentIndex = index;

      thumbs.forEach(function(t) { t.classList.remove('ijc-product__gallery-thumb--active'); });
      thumbs[index].classList.add('ijc-product__gallery-thumb--active');
      thumbs[index].scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});

      var thumb = thumbs[index];
      var src = thumb.getAttribute('data-src');
      var alt = thumb.getAttribute('data-alt') || '';
      if (mainMedia.tagName !== 'IMG') {
        var img = document.createElement('img');
        img.id = 'ijcMainMedia';
        img.style.cssText = 'width:100%;height:100%;object-fit:contain;cursor:zoom-in;transition:transform .3s';
        mainMedia.parentNode.replaceChild(img, mainMedia);
        mainMedia = img;
      }
      mainMedia.src = src;
      mainMedia.alt = alt;
    }

    G = goToSlide;
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { goToSlide(i); });
    });

    var prevBtn = I('ijcGalleryPrev');
    var nextBtn = I('ijcGalleryNext');
    if (prevBtn) prevBtn.addEventListener('click', function() { goToSlide(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goToSlide(currentIndex + 1); });

    var thumbsWrap = I('ijcGalleryThumbs');
    var upBtn = I('ijcThumbUp');
    var downBtn = I('ijcThumbDown');
    function updateScrollBtns() {
      if (!thumbsWrap || !upBtn || !downBtn) return;
      upBtn.disabled = thumbsWrap.scrollTop <= 2;
      downBtn.disabled = thumbsWrap.scrollTop + thumbsWrap.clientHeight >= thumbsWrap.scrollHeight - 2;
    }
    if (thumbsWrap && upBtn && downBtn) {
      var scrollAmt = 160;
      upBtn.addEventListener('click', function() { thumbsWrap.scrollBy({top: -scrollAmt, behavior: 'smooth'}); });
      downBtn.addEventListener('click', function() { thumbsWrap.scrollBy({top: scrollAmt, behavior: 'smooth'}); });
      thumbsWrap.addEventListener('scroll', updateScrollBtns);
      updateScrollBtns();
    }
  }

  /* Videos shown below the main image (grid for 1-3, carousel for 4+).
     Lazy-mounts posters / iframe embeds only when an item nears the viewport,
     keeps one video playing at a time, and wires the carousel arrows. */
  function initVideoGallery() {
    var wrap = I('ijcGalleryVideos');
    if (!wrap) return;
    var track = wrap.querySelector('.ijc-product__gallery-videos-track');
    var items = wrap.querySelectorAll('.ijc-product__gallery-videos-item');

    function mount(item) {
      var media = item.querySelector('video, iframe');
      if (!media) return;
      if (media.tagName === 'IFRAME' && media.dataset.src && !media.getAttribute('src')) media.setAttribute('src', media.dataset.src);
      if (media.tagName === 'VIDEO' && media.dataset.poster && !media.getAttribute('poster')) media.setAttribute('poster', media.dataset.poster);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) { if (e.isIntersecting) { mount(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '200px' });
      items.forEach(function(it) { io.observe(it); });
    } else {
      items.forEach(mount);
    }

    /* Only one video plays at a time. */
    wrap.querySelectorAll('video').forEach(function(v) {
      v.addEventListener('play', function() {
        wrap.querySelectorAll('video').forEach(function(o) { if (o !== v) { try { o.pause(); } catch (e) {} } });
      });
    });

    /* Carousel arrows (4+ videos, desktop). */
    var prev = wrap.querySelector('.ijc-product__gallery-videos-arrow--prev');
    var next = wrap.querySelector('.ijc-product__gallery-videos-arrow--next');
    var stepWidth = function() {
      var it = wrap.querySelector('.ijc-product__gallery-videos-item');
      return it ? it.getBoundingClientRect().width + 10 : 200;
    };
    if (track && prev) prev.addEventListener('click', function() { track.scrollBy({ left: -stepWidth(), behavior: 'smooth' }); });
    if (track && next) next.addEventListener('click', function() { track.scrollBy({ left: stepWidth(), behavior: 'smooth' }); });
  }

  function initVariants() {
    var optionGroups = Q('.ijc-product__option-group[data-option-index]');
    if (optionGroups.length === 0) return;

    function getSelectedOptions() {
      var opts = [];
      for (var i = 0; i < optionCount; i++) opts.push('');
      Q('.ijc-product__option-group:not([data-size-hidden]) .ijc-product__option-btn--selected').forEach(function(btn) {
        var idx = parseInt(btn.getAttribute('data-option-index'), 10);
        if (!isNaN(idx) && idx >= 0) opts[idx] = btn.getAttribute('data-value') || '';
      });
      return opts;
    }

    function findVariant(selectedOpts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < selectedOpts.length; j++) {
          if (selectedOpts[j] && v.options[j] !== selectedOpts[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function updateProduct(variant) {
      if (!variant) return;
      currentVariantId = variant.id;
      var idInput = I('ijcVariantId');
      if (idInput) idInput.value = variant.id;
      /* Tell the rest of the page which variant is active now. The wishlist heart listens
         to this so that switching metal/size re-points it at the right variant. */
      try {
        window.dispatchEvent(new CustomEvent('ijc:variant:change', { detail: { id: variant.id } }));
      } catch (e) {}
      var priceEl = I('ijcPrice');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var cmpEl = I('ijcComparePrice');
      if (cmpEl) {
        if (onSale) {
          cmpEl.textContent = formatMoney(variant.compare_at_price);
          cmpEl.hidden = false;
        } else {
          cmpEl.hidden = true;
        }
      }
      var deal = document.querySelector('#ijcGalleryMain .sh-badges--deal');
      if (deal) {
        var saleB = deal.querySelector('.sh-badge--sale');
        var discB = deal.querySelector('.sh-badge--discount');
        if (saleB) saleB.hidden = !onSale;
        if (discB) {
          if (onSale) {
            discB.textContent = '-' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + '%';
            discB.hidden = false;
          } else {
            discB.hidden = true;
          }
        }
      }
      var stockWrap = I('ijcStock');
      var stockText = I('ijcStockText');
      var addBtn = I('ijcAddToCart');
      if (variant.available) {
        stockWrap.classList.remove('ijc-product__stock--out');
        stockText.textContent = 'In Stock';
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
      } else {
        stockWrap.classList.add('ijc-product__stock--out');
        stockText.textContent = 'Out of Stock';
        addBtn.disabled = true;
        addBtn.textContent = 'Sold Out';
      }
      if (history.replaceState) {
        history.replaceState({ variant: variant.id }, '', window.location.pathname + '?variant=' + variant.id);
      }
      /* Match the variant's image by EXACT filename + break — a substring match
         would let e.g. "gold-ruby.jpg" wrongly match "white-gold-ruby.jpg". */
      if(G&&variant.featured_image){var f=variant.featured_image.src.replace(/\?.*/,'').replace(/.*\//,'');var gt=Q('.ijc-product__gallery-thumb');for(var gi=0;gi<gt.length;gi++){var ds=gt[gi].dataset.src;if(ds&&ds.replace(/\?.*/,'').replace(/.*\//,'')===f){G(gi);break;}}}
    }

    /* Contextual metal availability. A metal (e.g. "14K Gold") only exists for
       some styles — Mini Claddagh is 9K/10K only, Heavy Claddagh adds 18K, etc.
       The Liquid disables a metal only when it is unavailable across the WHOLE
       product, so metals that exist for another style used to stay clickable and
       lead to a dead variant. Here we hide any metal that has no available
       variant matching the currently-chosen non-metal options, and if the metal
       in hand becomes hidden we drop to the first one that is available.
       Returns true when it changed the selected metal. */
    function refreshMetalAvailability() {
      var metalGroup = document.querySelector('.ijc-product__option-group[data-metal-group]');
      if (!metalGroup) return false;
      var metalIdx = parseInt(metalGroup.getAttribute('data-option-index'), 10);
      if (isNaN(metalIdx)) return false;
      var sel = getSelectedOptions();
      var btns = metalGroup.querySelectorAll('.ijc-product__option-btn');
      var firstVisible = null;
      var selectedStillVisible = false;
      btns.forEach(function(btn) {
        var metalVal = btn.getAttribute('data-value') || '';
        var ok = variants.some(function(v) {
          if (!v.available) return false;
          if (v.options[metalIdx] !== metalVal) return false;
          for (var j = 0; j < sel.length; j++) {
            if (j === metalIdx) continue;
            if (sel[j] && v.options[j] !== sel[j]) return false;
          }
          return true;
        });
        if (ok) {
          btn.style.display = '';
          btn.disabled = false;
          btn.removeAttribute('aria-hidden');
          if (!firstVisible) firstVisible = btn;
          if (btn.classList.contains('ijc-product__option-btn--selected')) selectedStillVisible = true;
        } else {
          btn.style.display = 'none';
          btn.disabled = true;
          btn.setAttribute('aria-hidden', 'true');
          btn.classList.remove('ijc-product__option-btn--selected');
        }
      });
      if (!selectedStillVisible && firstVisible) {
        firstVisible.classList.add('ijc-product__option-btn--selected');
        return true;
      }
      return false;
    }

    Q('.ijc-product__option-btn:not([disabled])').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(this.getAttribute('data-option-index'), 10);
        var group = this.closest('.ijc-product__option-group');
        if (!group) return;
        group.querySelectorAll('.ijc-product__option-btn').forEach(function(b) {
          b.classList.remove('ijc-product__option-btn--selected');
        });
        this.classList.add('ijc-product__option-btn--selected');
        /* Re-filter the metals for the option just chosen, then resolve the variant
           from whatever is selected after that (the metal may have auto-switched). */
        refreshMetalAvailability();
        var opts = getSelectedOptions();
        var variant = findVariant(opts);
        if (variant) updateProduct(variant);
        /* Reverse sync: update mobile dropdown when desktop button clicked */
        var sel = group.querySelector('.ijc-product__size-select');
        if (sel) sel.value = this.getAttribute('data-value') || '';
      });
    });

    /* Filter the metals for the style shown on first paint, and if the preselected
       metal is not available for it, switch to one that is and reprice. */
    if (refreshMetalAvailability()) {
      var v0 = findVariant(getSelectedOptions());
      if (v0) updateProduct(v0);
    }

    /* Mobile size dropdown → clicks hidden desktop button */
    Q('.ijc-product__size-select').forEach(function(sel) {
      sel.addEventListener('change', function() {
        if (!sel.value) return;
        var group = sel.closest('.ijc-product__option-group');
        if (!group) return;
        var btn = group.querySelector('.ijc-product__option-btn[data-value="' + sel.value.replace(/"/g, '\\"') + '"]');
        if (btn && !btn.disabled) btn.click();
      });
    });
  }

  function initQuantity() {
    var qtyInput = I('ijcQtyInput');
    var minusBtn = I('ijcQtyMinus');
    var plusBtn = I('ijcQtyPlus');
    if (!qtyInput) return;

    minusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });

    plusBtn.addEventListener('click', function() {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

  function initAccordions() {
    Q('.ijc-product__accordion-trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var accordion = this.closest('.ijc-product__accordion');
        var isOpen = accordion.classList.contains('is-open');
        accordion.classList.toggle('is-open');
        this.setAttribute('aria-expanded', !isOpen);
      });
    });
  }

  function initHelpPopup() {
    ['ijcHelpWrap', 'ijcHelpWrapMobile'].forEach(function(id) {
      var wrap = I(id);
      if (!wrap) return;
      var trigger = wrap.querySelector('.ijc-product__help-trigger');
      trigger.addEventListener('click', function() {
        wrap.classList.toggle('is-open');
      });
      document.addEventListener('click', function(e) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('is-open');
        }
      });
    });
  }

  function initSmoothScroll() {
    Q('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href.length < 2) return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var offset = 140;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  function initActions() {
    var shareWrap = I('ijcShareWrap');
    var shareBtn = I('ijcShareBtn');
    var shareDropdown = I('ijcShareDropdown');
    var copyBtn = I('ijcShareCopy');
    if (shareBtn && shareWrap) {
      shareBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        shareWrap.classList.toggle('is-open');
      });
      document.addEventListener('click', function() { shareWrap.classList.remove('is-open'); });
      if (shareDropdown) shareDropdown.addEventListener('click', function(e) { e.stopPropagation(); });
    }
    if (copyBtn) {
      copyBtn.addEventListener('click', function() {
        navigator.clipboard.writeText(window.location.href).then(function() {
          copyBtn.textContent = 'Copied!';
          setTimeout(function() { copyBtn.textContent = 'Copy link'; }, 1500);
        });
      });
    }
  }

  function initBirthstone() {
    /* Birthstone month-to-color mapping for preview strip dots */
    var BIRTHSTONES = [
      { month: 'January',   stone: 'Garnet',      color: '#9B111E' },
      { month: 'February',  stone: 'Amethyst',    color: '#9966CC' },
      { month: 'March',     stone: 'Aquamarine',  color: '#7FFFD4' },
      { month: 'April',     stone: 'Crystal',     color: '#B9F2FF' },
      { month: 'May',       stone: 'Emerald',     color: '#50C878' },
      { month: 'June',      stone: 'Lt. Amethyst',color: '#A4C3B2' },
      { month: 'July',      stone: 'Ruby',        color: '#E0115F' },
      { month: 'August',    stone: 'Peridot',     color: '#B4C424' },
      { month: 'September', stone: 'Sapphire',    color: '#0F52BA' },
      { month: 'October',   stone: 'Rose',        color: '#A8C3BC' },
      { month: 'November',  stone: 'Topaz',       color: '#FFC87C' },
      { month: 'December',  stone: 'Blue Topaz',  color: '#4D5B9E' }
    ];

    var cardsContainer = I('ijcBirthstoneCards');
    var stoneCountContainer = I('ijcStoneCountCards');
    /* Use stone count cards if visual cards are disabled */
    if (!cardsContainer && stoneCountContainer) cardsContainer = stoneCountContainer;
    var monthsSection  = I('ijcBirthstoneMonths');
    var monthsLabel    = I('ijcMonthsLabel');
    var previewStrip   = I('ijcBirthstonePreview');
    var previewLabel   = I('ijcPreviewLabel');
    var validationMsg  = I('ijcBirthstoneValidation');
    var addBtn         = I('ijcAddToCart');
    var step1          = I('ijcStep1');
    var step1Num       = I('ijcStep1Num');
    var step2          = I('ijcStep2');
    var step2Num       = I('ijcStep2Num');

    if (!cardsContainer) return;

    /* currentStoneCount = total number of dropdowns/stones to show.
       Set during init and updated on every card click. */
    var currentStoneCount = 0;

    /* Parse total stone count from option value. Supports two formats:
       - "X Heart Stone + N Birthstones" → X + N total stones
       - "N Heart Stones" → N total stones */
    function parseStoneCount(val) {
      if (!val) return 0;
      var plus = val.match(/\+\s*(\d+)/);
      var leading = val.match(/^(\d+)/);
      if (plus) {
        var hearts = leading ? parseInt(leading[1], 10) : 1;
        return hearts + parseInt(plus[1], 10);
      }
      return leading ? parseInt(leading[1], 10) : 0;
    }

    /* Lookup birthstone by BSS_PO value text like "January - Garnet".
       Uses word-boundary regex to avoid false matches (e.g. "May" in "Maypole"). */
    function parseBSSValue(text) {
      if (!text) return null;
      for (var i = 0; i < BIRTHSTONES.length; i++) {
        var re = new RegExp('\\b' + BIRTHSTONES[i].month + '\\b', 'i');
        if (re.test(text)) return BIRTHSTONES[i];
      }
      return null;
    }

    /* ── Step progress indicator ── */
    function updateSteps(step, allComplete) {
      step1.className = 'ijc-product__birthstone-step';
      step2.className = 'ijc-product__birthstone-step';
      step1Num.textContent = '1';
      step2Num.textContent = '2';
      if (allComplete) {
        step1.classList.add('ijc-product__birthstone-step--done');
        step1Num.innerHTML = '&#10003;';
        step2.classList.add('ijc-product__birthstone-step--done');
        step2Num.innerHTML = '&#10003;';
      } else if (step >= 2) {
        step1.classList.add('ijc-product__birthstone-step--done');
        step1Num.innerHTML = '&#10003;';
        step2.classList.add('ijc-product__birthstone-step--active');
      } else {
        step1.classList.add('ijc-product__birthstone-step--active');
      }
    }

    /* ── Per-stone price injection — reads from IJC_CONFIG.birthstonePrices metafield ── */
    function injectPerStonePrices() {
      var prices = C.birthstonePrices || {};
      /* Extract stone count from card: use data-stone-count if present, else parse data-value */
      function getStoneCount(card) {
        var n = parseInt(card.getAttribute('data-stone-count'), 10);
        if (n) return n;
        return parseStoneCount(card.getAttribute('data-value') || '');
      }
      /* Process all birthstone cards in all containers */
      Q('.ijc-product__birthstone-card').forEach(function(card) {
        var n = getStoneCount(card);
        if (!n) return;
        var priceEl = card.querySelector('.ijc-product__birthstone-card-price');
        /* Metafield stores price in dollars (e.g. 295); formatMoney expects cents */
        var dollars = prices[String(n)];
        if (dollars && priceEl) {
          priceEl.textContent = formatMoney(Math.round(parseFloat(dollars) * 100));
        }
        if (n >= 3 && dollars && !card.querySelector('.ijc-product__birthstone-card-pps')) {
          var pps = document.createElement('span');
          pps.className = 'ijc-product__birthstone-card-pps';
          pps.textContent = formatMoney(Math.round(parseFloat(dollars) * 100 / n)) + '/stone';
          card.appendChild(pps);
        }
      });
    }

    /* ── Show/hide dropdown wraps based on selected stone count ── */
    function showBSSGroups(count) {
      var container = I('ijcBirthstoneDropdowns');
      if (!container) return;
      var wraps = Q('[data-group-index]', container);
      wraps.forEach(function(wrap) {
        var idx = parseInt(wrap.getAttribute('data-group-index'), 10);
        var sel = wrap.querySelector('select');
        if (idx < count) {
          wrap.removeAttribute('data-ijc-hidden');
        } else {
          wrap.setAttribute('data-ijc-hidden', 'true');
          if (sel) sel.value = '';
        }
      });
    }

    /* ── Bind change events to native <select> dropdowns (pre-rendered in Liquid) ── */
    function bindNativeSelects() {
      var container = I('ijcBirthstoneDropdowns');
      if (!container) return;
      Q('select', container).forEach(function(sel) {
        sel.addEventListener('change', function() {
          this.classList.remove('ijc-product__birthstone-select--error');
          if (this.value) this.classList.add('ijc-product__birthstone-select--filled');
          else this.classList.remove('ijc-product__birthstone-select--filled');
          updatePreview();
          validateSelections();
        });
      });
    }

    /* ── Card click handler factory — handles both visual-only and variant-controlling cards ── */
    function bindCardClicks(container, isVariantCard) {
      if (!container) return;
      container.querySelectorAll('.ijc-product__birthstone-card:not([disabled])').forEach(function(card) {
        card.addEventListener('click', function() {
          /* Toggle selected state within this container */
          container.querySelectorAll('.ijc-product__birthstone-card').forEach(function(c) {
            c.classList.remove('ijc-product__birthstone-card--selected');
            c.setAttribute('aria-checked', 'false');
          });
          this.classList.add('ijc-product__birthstone-card--selected');
          this.setAttribute('aria-checked', 'true');

          var cardValue = this.getAttribute('data-value');
          var optionIndex = parseInt(this.getAttribute('data-option-index'), 10);

          if (isVariantCard) {
            /* Stone count card — update current stone count and trigger variant selection */
            currentStoneCount = parseStoneCount(cardValue);
            if (monthsLabel) monthsLabel.textContent = 'Customize your ' + currentStoneCount + '-stone necklace';

            /* Trigger variant selection via hidden button */
            var btn = document.querySelector(
              '.ijc-product__option-btn[data-option-index="' + optionIndex + '"][data-value="' + cardValue.replace(/"/g, '&quot;') + '"]'
            );
            if (btn) btn.click();

            /* Update gallery to match card image */
            var cardImg = this.querySelector('.ijc-product__birthstone-card-img');
            if (G && cardImg) {
              var imgFile = (cardImg.getAttribute('src') || '').replace(/\?.*/, '').replace(/.*\//, '');
              if (imgFile) {
                var thumbs = Q('.ijc-product__gallery-thumb');
                for (var ti = 0; ti < thumbs.length; ti++) {
                  if (((thumbs[ti].dataset.src || '').replace(/\?.*/, '').replace(/.*\//, '')) === imgFile) { G(ti); break; }
                }
              }
            }

            /* Update UI state */
            monthsSection.style.display = '';
            showBSSGroups(currentStoneCount);
            updateSteps(2, false);
            updatePreview();
            validateSelections();
          } else {
            /* Visual-only "Select An Option" card — update stone count and wire to hidden button */
            currentStoneCount = parseInt(this.getAttribute('data-stone-count'), 10) || 0;
            if (monthsLabel) monthsLabel.textContent = 'Customize your ' + currentStoneCount + '-stone necklace';

            /* Wire to native variant system — click the hidden stone count option button */
            var stoneOptPos = C.stoneCountOptionPos;
            if (stoneOptPos !== null && stoneOptPos !== undefined && cardValue) {
              var btn = document.querySelector(
                '.ijc-product__option-btn[data-option-index="' + stoneOptPos + '"][data-value="' + cardValue.replace(/"/g, '&quot;') + '"]'
              );
              if (btn) btn.click(); /* Triggers initVariants()'s click handler */
            }

            /* Update main gallery image to match selected card */
            if (G) {
              var stonePattern = currentStoneCount + '-stone';
              var thumbs = Q('.ijc-product__gallery-thumb');
              for (var ti = 0; ti < thumbs.length; ti++) {
                if ((thumbs[ti].dataset.src || '').indexOf(stonePattern) !== -1) {
                  G(ti);
                  break;
                }
              }
            }

            showBSSGroups(currentStoneCount);
            updateSteps(2, false);
            updatePreview();
            validateSelections();
          }
        });
      });
    }

    /* ── Preview strip (Endowment Effect) ──
       Shows a colored dot for each visible dropdown. Reads from native <select> values. */
    function updatePreview() {
      if (!previewStrip) return;
      var dots = previewStrip.querySelectorAll('.ijc-product__birthstone-dot,.ijc-product__birthstone-dot-plus');
      dots.forEach(function(d) { d.remove(); });

      var container = I('ijcBirthstoneDropdowns');
      var selects = container ? Q('select', container) : [];
      var filledCount = 0;
      var visibleCount = 0;

      selects.forEach(function(sel, idx) {
        var wrap = sel.closest('[data-group-index]');
        if (!wrap || wrap.hasAttribute('data-ijc-hidden')) return;

        var b = sel.value ? parseBSSValue(sel.value) : null;

        var dot = document.createElement('span');
        dot.className = 'ijc-product__birthstone-dot' + (b ? ' ijc-product__birthstone-dot--filled' : '');

        var circle = document.createElement('span');
        circle.className = 'ijc-product__birthstone-dot-circle';
        circle.style.background = b ? b.color : '#ddd';
        if (b) circle.style.boxShadow = '0 0 0 2px ' + b.color + '33';

        dot.appendChild(circle);
        var label = wrap.querySelector('label');
        dot.appendChild(document.createTextNode(b ? b.stone : (label ? label.textContent : 'Stone ' + (idx + 1))));
        previewStrip.appendChild(dot);

        if (b) filledCount++;
        visibleCount++;

        if (visibleCount < currentStoneCount) {
          var plus = document.createElement('span');
          plus.className = 'ijc-product__birthstone-dot-plus';
          plus.textContent = '+';
          previewStrip.appendChild(plus);
        }
      });

      var allDone = filledCount === visibleCount && visibleCount > 0;
      previewStrip.classList.toggle('ijc-product__birthstone-preview--complete', allDone);
      previewLabel.textContent = allDone ? 'Your necklace:' : 'Your necklace (' + filledCount + '/' + visibleCount + ' selected):';
    }

    /* ── Validation — all visible dropdowns must have a selection ── */
    function validateSelections() {
      var container = I('ijcBirthstoneDropdowns');
      var visibleSelects = Array.from(container ? Q('[data-group-index]:not([data-ijc-hidden]) select', container) : []);
      var allFilled = visibleSelects.length > 0 && visibleSelects.every(function(s) { return s.value !== ''; });

      if (allFilled && currentStoneCount > 0) {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
        if (validationMsg) validationMsg.classList.remove('ijc-product__birthstone-validation--visible');
        updateSteps(2, true);
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'Add to Cart';
        if (validationMsg) validationMsg.classList.add('ijc-product__birthstone-validation--visible');
        updateSteps(2, false);
      }
    }

    /* ── Init ── */
    var _initCard = cardsContainer.querySelector('.ijc-product__birthstone-card--selected');
    if (_initCard) {
      var stoneCount = parseInt(_initCard.getAttribute('data-stone-count'), 10);
      if (!stoneCount) stoneCount = parseStoneCount(_initCard.getAttribute('data-value') || '');
      currentStoneCount = stoneCount;
    } else {
      currentStoneCount = 0;
    }

    injectPerStonePrices();
    bindNativeSelects();
    /* Bind card clicks for both visual-only and variant-controlling cards */
    var visualCardsContainer = I('ijcBirthstoneCards');
    stoneCountContainer = I('ijcStoneCountCards');
    if (visualCardsContainer) bindCardClicks(visualCardsContainer, false);
    if (stoneCountContainer) bindCardClicks(stoneCountContainer, true);
    if (currentStoneCount > 0) {
      monthsSection.style.display = '';
    }
    if (monthsLabel && currentStoneCount > 0) {
      monthsLabel.textContent = 'Customize your ' + currentStoneCount + '-stone necklace';
    }
    showBSSGroups(currentStoneCount);
    updateSteps(2, false);
    updatePreview();
    validateSelections();

    /* ── Bypass BSS_PO form submit interception ──
       Convert the Add to Cart button from type="submit" to type="button" so
       clicking it never triggers the form's submit event. BSS_PO only listens
       for submit events, so it is completely bypassed. We handle cart add
       ourselves via fetch. */
    if (addBtn) {
      addBtn.type = 'button';
      addBtn.addEventListener('click', function() {
        if (addBtn.disabled) return;

        var formData = new FormData();
        var variantInput = I('ijcVariantId');
        var qtyInput = I('ijcQtyInput');
        formData.append('id', variantInput ? variantInput.value : currentVariantId);
        formData.append('quantity', qtyInput ? (parseInt(qtyInput.value) || 1) : 1);

        /* Append all visible birthstone selects as line item properties */
        var dropContainer = I('ijcBirthstoneDropdowns');
        if (dropContainer) {
          Array.from(Q('[data-group-index]:not([data-ijc-hidden]) select', dropContainer)).forEach(function(sel) {
            if (sel.name && sel.value) formData.append(sel.name, sel.value);
          });
        }

        var _crestEl = I('ijcCrestName');
        if (_crestEl && _crestEl.value.trim()) formData.append('properties[Family Name]', _crestEl.value.trim());

        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function(r) {
            if (!r.ok) throw new Error('cart error');
            return r.json();
          })
          .then(function() { window.location.href = '/cart'; })
          .catch(function() {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
            alert('Sorry, there was a problem adding this item. Please try again.');
          });
      });
    }
  }

  /* ── Single-birthstone products ──
     Desktop: 12 month cards in a grid with variant images.
     Mobile: a <select> dropdown with preview strip.
     Both sync selection and trigger variant updates via hidden option buttons. */
  function initSingleBirthstone() {
    var BIRTHSTONES = [
      { month: 'January',   stone: 'Garnet',      color: '#9B111E' },
      { month: 'February',  stone: 'Amethyst',    color: '#9966CC' },
      { month: 'March',     stone: 'Aquamarine',  color: '#7FFFD4' },
      { month: 'April',     stone: 'Crystal',     color: '#B9F2FF' },
      { month: 'May',       stone: 'Emerald',     color: '#50C878' },
      { month: 'June',      stone: 'Lt. Amethyst',color: '#A4C3B2' },
      { month: 'July',      stone: 'Ruby',        color: '#E0115F' },
      { month: 'August',    stone: 'Peridot',     color: '#B4C424' },
      { month: 'September', stone: 'Sapphire',    color: '#0F52BA' },
      { month: 'October',   stone: 'Rose',        color: '#A8C3BC' },
      { month: 'November',  stone: 'Topaz',       color: '#FFC87C' },
      { month: 'December',  stone: 'Blue Topaz',  color: '#4D5B9E' }
    ];

    var cardsContainer = I('ijcSingleBsCards');
    var mobileSelect   = I('ijcSingleBsSelect');
    var previewStrip   = I('ijcSingleBsPreview');
    var previewLabel   = I('ijcSingleBsPreviewLabel');
    var addBtn         = I('ijcAddToCart');

    if (!cardsContainer && !mobileSelect) return;

    var optionIndex = cardsContainer
      ? parseInt(cardsContainer.getAttribute('data-option-index'), 10)
      : parseInt(mobileSelect.getAttribute('data-option-index'), 10);

    function parseBSSValue(text) {
      if (!text) return null;
      for (var i = 0; i < BIRTHSTONES.length; i++) {
        var re = new RegExp('\\b' + BIRTHSTONES[i].month + '\\b', 'i');
        if (re.test(text)) return BIRTHSTONES[i];
      }
      return null;
    }

    /* Click the hidden option button to trigger initVariants() price/stock/gallery update */
    function selectVariant(value) {
      var btn = document.querySelector(
        '.ijc-product__option-btn[data-option-index="' + optionIndex + '"][data-value="' + value.replace(/"/g, '&quot;') + '"]'
      );
      if (btn) btn.click();
    }

    /* Update preview strip (visible on mobile) */
    function updatePreview() {
      if (!previewStrip) return;
      var dots = previewStrip.querySelectorAll('.ijc-product__birthstone-dot');
      dots.forEach(function(d) { d.remove(); });

      var selectedValue = '';
      if (mobileSelect && mobileSelect.value) {
        selectedValue = mobileSelect.value;
      } else if (cardsContainer) {
        var sel = cardsContainer.querySelector('.ijc-product__birthstone-card--selected');
        if (sel) selectedValue = sel.getAttribute('data-value') || '';
      }

      var b = parseBSSValue(selectedValue);
      if (b) {
        var dot = document.createElement('span');
        dot.className = 'ijc-product__birthstone-dot ijc-product__birthstone-dot--filled';
        var circle = document.createElement('span');
        circle.className = 'ijc-product__birthstone-dot-circle';
        circle.style.background = b.color;
        circle.style.boxShadow = '0 0 0 2px ' + b.color + '33';
        dot.appendChild(circle);
        dot.appendChild(document.createTextNode(b.stone));
        previewStrip.appendChild(dot);
        previewLabel.textContent = C.isRing ? 'Your ring:' : 'Your necklace:';
        previewStrip.classList.add('ijc-product__birthstone-preview--complete');
      } else {
        previewLabel.textContent = C.isRing ? 'Your ring (0/1 selected):' : 'Your necklace (0/1 selected):';
        previewStrip.classList.remove('ijc-product__birthstone-preview--complete');
      }
    }

    /* Sync desktop cards ↔ mobile dropdown */
    function syncCardToDropdown(value) {
      if (mobileSelect) mobileSelect.value = value;
    }
    function syncDropdownToCards(value) {
      if (!cardsContainer) return;
      cardsContainer.querySelectorAll('.ijc-product__birthstone-card').forEach(function(c) {
        var match = c.getAttribute('data-value') === value;
        c.classList.toggle('ijc-product__birthstone-card--selected', match);
        c.setAttribute('aria-checked', match ? 'true' : 'false');
      });
    }

    /* Update Add to Cart button state */
    function updateAddBtn() {
      var hasSelection = false;
      if (mobileSelect && mobileSelect.value) hasSelection = true;
      if (!hasSelection && cardsContainer) {
        hasSelection = !!cardsContainer.querySelector('.ijc-product__birthstone-card--selected');
      }
      if (addBtn) {
        addBtn.disabled = !hasSelection;
        addBtn.textContent = 'Add to Cart';
      }
    }

    /* Desktop: card click handler */
    if (cardsContainer) {
      cardsContainer.querySelectorAll('.ijc-product__birthstone-card').forEach(function(card) {
        card.addEventListener('click', function() {
          cardsContainer.querySelectorAll('.ijc-product__birthstone-card').forEach(function(c) {
            c.classList.remove('ijc-product__birthstone-card--selected');
            c.setAttribute('aria-checked', 'false');
          });
          this.classList.add('ijc-product__birthstone-card--selected');
          this.setAttribute('aria-checked', 'true');

          var value = this.getAttribute('data-value');
          selectVariant(value);
          syncCardToDropdown(value);
          updatePreview();
          updateAddBtn();
        });
      });
    }

    /* Mobile: dropdown change handler */
    if (mobileSelect) {
      mobileSelect.addEventListener('change', function() {
        var value = this.value;
        if (value) {
          selectVariant(value);
          syncDropdownToCards(value);
        }
        updatePreview();
        updateAddBtn();
      });
    }

    /* Init state */
    updatePreview();
    updateAddBtn();

    /* Fetch-based Add to Cart to bypass BSS_PO */
    if (addBtn) {
      addBtn.type = 'button';
      addBtn.addEventListener('click', function() {
        if (addBtn.disabled) return;

        var formData = new FormData();
        var variantInput = I('ijcVariantId');
        var qtyInput = I('ijcQtyInput');
        formData.append('id', variantInput ? variantInput.value : currentVariantId);
        formData.append('quantity', qtyInput ? (parseInt(qtyInput.value) || 1) : 1);

        var _crestEl2 = I('ijcCrestName');
        if (_crestEl2 && _crestEl2.value.trim()) formData.append('properties[Family Name]', _crestEl2.value.trim());

        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function(r) {
            if (!r.ok) throw new Error('cart error');
            return r.json();
          })
          .then(function() { window.location.href = '/cart'; })
          .catch(function() {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
            alert('Sorry, there was a problem adding this item. Please try again.');
          });
      });
    }
  }

  function initSizeGuide() {
    var backdrop = I('ijcSizeModal');
    var inner = I('ijcSizeModalInner');
    if (!backdrop) return;

    function openModal() {
      backdrop.classList.add('ijc-size-modal-backdrop--open');
      var closeBtn = backdrop.querySelector('[data-ijc-size-guide-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      backdrop.classList.remove('ijc-size-modal-backdrop--open');
    }

    /* Event delegation — handles dynamically injected buttons from ijc-optis.js */
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-ijc-size-guide-open]')) { openModal(); return; }
      if (e.target.closest('[data-ijc-size-guide-close]')) { closeModal(); return; }
    });
    backdrop.addEventListener('click', function(e) {
      if (e.target === backdrop) closeModal();
    });
    if (inner) inner.addEventListener('click', function(e) {
      if (e.target.closest('[data-ijc-size-guide-close]')) { closeModal(); return; }
      e.stopPropagation();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && backdrop.classList.contains('ijc-size-modal-backdrop--open')) closeModal();
    });
  }

  /* ── Ring size validation (OPTIS-managed finger sizes) ── */
  function initRingValidation() {
    if (!C.isRing || C.isBirthstone) return;

    function isRingSizeSelected() {
      var visibleBlock = document.querySelector('[data-ijc-optis-visible]');
      if (!visibleBlock) return true;
      var anyChecked = visibleBlock.querySelector('input[type="radio"]:checked');
      if (anyChecked) return true;
      var mobileSel = visibleBlock.querySelector('.ijc-optis-mobile-select');
      if (mobileSel && mobileSel.value) return true;
      return false;
    }
    function showRingValidation() {
      var val = document.querySelector('.ijc-optis-validation');
      if (val) val.classList.add('ijc-optis-validation--visible');
      var visibleBlock = document.querySelector('[data-ijc-optis-visible]');
      if (visibleBlock) visibleBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* Layer 1: capture-phase click on ATC button */
    document.addEventListener('click', function(e) {
      var atcBtn = e.target.closest('#ijcAddToCart');
      if (!atcBtn) return;
      if (!isRingSizeSelected()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showRingValidation();
      }
    }, true);

    /* Layer 2: capture-phase form submit interceptor */
    var form = I('ijcCartForm');
    if (form) {
      form.addEventListener('submit', function(e) {
        if (!isRingSizeSelected()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          showRingValidation();
        }
      }, true);
    }
  }

  function initCrossSell() {
    var wrap = I('ijcCrossSell');
    if (!wrap) return;

    /* 2026-08-19: the staged "bundle" is gone. Each Complete the Look card is now a plain
       offer that adds ITSELF to the cart on click and goes straight to /cart. Removed with it:
       the pre-selection that put non-ring items in the bundle on page load, the running
       "Bundle total", the "Add Bundle to Cart" button, and the multi-stone gating that only
       existed because the bundle carried the MAIN product's birthstone properties. The main
       product keeps its own separate Add to Cart, untouched. */

    /* Add ONE cross-sell variant to the cart, then go to the cart page. */
    function addCrossSellToCart(btn, variantId) {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      }).then(function(res) {
        if (res.ok) {
          window.location.href = '/cart';
        } else {
          btn.disabled = false;
          btn.textContent = 'Error \u2014 Try Again';
        }
      }).catch(function() {
        btn.disabled = false;
        btn.textContent = 'Error \u2014 Try Again';
      });
    }

    /* --- Thumbnail lightbox: click a cross-sell photo (or its zoom icon) to see it enlarged.
       Uses the currently-shown src (so it reflects the chosen metal) bumped to width=1000. --- */
    var lightbox = document.createElement('div');
    lightbox.className = 'ijc-product__lightbox';
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.innerHTML = '<button type="button" class="ijc-product__lightbox-close" aria-label="Close">×</button><img class="ijc-product__lightbox-img" alt="">';
    document.body.appendChild(lightbox);
    var lightboxImg = lightbox.querySelector('.ijc-product__lightbox-img');
    function openLightbox(src, alt) {
      if (!src) return;
      var large = src.replace(/([?&])width=\d+/, '$1width=1000');
      if (large === src && src.indexOf('width=') === -1) {
        large = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1000';
      }
      lightboxImg.src = large;
      lightboxImg.alt = alt || '';
      lightbox.classList.add('ijc-product__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'false');
    }
    function closeLightbox() {
      lightbox.classList.remove('ijc-product__lightbox--open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxImg.removeAttribute('src');
    }
    lightbox.addEventListener('click', function(e) {
      if (e.target === lightbox || e.target.closest('.ijc-product__lightbox-close')) closeLightbox();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && lightbox.classList.contains('ijc-product__lightbox--open')) closeLightbox();
    });
    wrap.addEventListener('click', function(e) {
      var ib = e.target.closest('.ijc-product__cross-card-imgbtn');
      if (!ib) return;
      var im = ib.querySelector('.ijc-product__cross-card-img');
      if (im) openLightbox(im.getAttribute('src'), im.getAttribute('alt'));
    });

    /* Map a metal name to a colour bucket so "14K Gold" (necklace) matches "14K Yellow Gold" (earrings) */
    function metalColor(name) {
      name = (name || '').toLowerCase();
      if (name.indexOf('white') >= 0) return 'white';
      if (name.indexOf('rose') >= 0) return 'rose';
      if (name.indexOf('two-tone') >= 0 || name.indexOf('two tone') >= 0) return 'two-tone';
      if (name.indexOf('yellow') >= 0) return 'yellow';
      if (name.indexOf('silver') >= 0) return 'silver';
      if (name.indexOf('platinum') >= 0) return 'platinum';
      if (name.indexOf('gold') >= 0) return 'yellow';   /* plain "gold" = yellow gold */
      return name;
    }
    /* Coarser warm/cool grouping — fallback when exact colours don't line up across products
       (e.g. main "14K Gold" vs a ring offered only in "Two-Tone Gold" / "White Gold"). */
    function metalFamily(name) {
      name = (name || '').toLowerCase();
      if (name.indexOf('white') >= 0 || name.indexOf('silver') >= 0 || name.indexOf('platinum') >= 0) return 'white';
      if (name.indexOf('gold') >= 0 || name.indexOf('yellow') >= 0 || name.indexOf('rose') >= 0 ||
          name.indexOf('two-tone') >= 0 || name.indexOf('two tone') >= 0) return 'gold';
      return 'other';
    }
    /* Karat / material (14k, 10k, 9k, silver, platinum) — distinguishes same-colour metals */
    function metalKarat(name) {
      name = (name || '').toLowerCase();
      var m = name.match(/(\d{1,2})\s*k\b/);
      if (m) return m[1] + 'k';
      if (name.indexOf('sterling') >= 0 || name.indexOf('silver') >= 0) return 'silver';
      if (name.indexOf('platinum') >= 0) return 'platinum';
      return '';
    }
    function metalOxidized(name) {
      return (name || '').toLowerCase().indexOf('oxid') >= 0;   /* oxidized / oxidised */
    }
    /* Match score: colour MUST match, then reward same karat and same finish.
       -1 = different colour (not a candidate for the exact pass). */
    function metalScore(mainName, otherName) {
      if (metalColor(mainName) !== metalColor(otherName)) return -1;
      var s = 100;
      if (metalKarat(mainName) === metalKarat(otherName)) s += 10;
      if (metalOxidized(mainName) === metalOxidized(otherName)) s += 5;
      return s;
    }
    /* The main product's currently-selected metal value (null if it has no metal option) */
    function mainMetalValue() {
      var groups = document.querySelectorAll('.ijc-product__option-group[data-option-index]');
      for (var i = 0; i < groups.length; i++) {
        var label = groups[i].querySelector('.ijc-product__option-label');
        var nm = label ? label.textContent.toLowerCase() : '';
        if (nm.indexOf('metal') >= 0 || nm.indexOf('colour') >= 0 || nm.indexOf('color') >= 0) {
          var sel = groups[i].querySelector('.ijc-product__option-btn--selected');
          if (sel) return sel.getAttribute('data-value');
          var dd = groups[i].querySelector('select');
          if (dd) return dd.value;
        }
      }
      return null;
    }
    /* Mirror the main metal onto every cross-sell card that has a metal option (display only) */
    function syncCrossSellMetal() {
      var mv = mainMetalValue();
      if (mv) {
        wrap.querySelectorAll('.ijc-product__cross-card').forEach(function(c) {
          if (typeof c._syncMetal === 'function') c._syncMetal(mv);
        });
        /* If every cross-sell card ended up hidden (e.g. two-tone with no two-tone items),
           hide the whole "Complete the Look" section so it isn't left empty. */
        var anyVisible = false;
        wrap.querySelectorAll('.ijc-product__cross-card').forEach(function(c) {
          if (c.style.display !== 'none') anyVisible = true;
        });
        wrap.style.display = anyVisible ? '' : 'none';
      }
      if (typeof refreshBundle === 'function') refreshBundle();
    }

    /* Set up each card. Every card is now an independent Add to Cart. */
    wrap.querySelectorAll('.ijc-product__cross-card').forEach(function(card) {
      var btn = card.querySelector('.ijc-product__cross-card-add');
      if (!btn || btn.classList.contains('ijc-product__cross-card-add--link')) return;

      var hasOptions = card.getAttribute('data-has-options') === 'true';

      /* Amazon-style combined add: give every card an "include" checkbox (checked by default).
         One "Add both to Cart" button at the foot of the section adds all checked, in-stock
         cards in a single /cart/add.js call. The per-card Add button stays in the DOM (its
         option/metal wiring still runs) but is hidden via CSS. */
      var cbx = document.createElement('input');
      cbx.type = 'checkbox';
      cbx.checked = true;
      cbx.className = 'ijc-product__cross-card-check';
      cbx.setAttribute('aria-label', 'Include this item in Add both to Cart');
      card.insertBefore(cbx, card.firstChild);
      card._bundleCheckbox = cbx;
      cbx.addEventListener('change', function() {
        card.classList.toggle('ijc-product__cross-card--unchecked', !cbx.checked);
        refreshBundle();
      });

      if (hasOptions) {
        var priceEl = card.querySelector('.ijc-product__cross-card-price');
        /* base (cheapest) price shown before options are chosen */
        var cardBase = parseInt(card.getAttribute('data-price'), 10) || 0;
        var imgEl = card.querySelector('.ijc-product__cross-card-img');
        var baseImg = imgEl ? imgEl.getAttribute('src') : '';
        var optsWrap = card.querySelector('.ijc-product__cross-opts');
        var variants = [];
        try { variants = JSON.parse(optsWrap.getAttribute('data-variants')) || []; } catch (e) { variants = []; }
        var optGroups = optsWrap ? Array.prototype.slice.call(optsWrap.querySelectorAll('.ijc-product__cross-opt')) : [];
        var selected = {};

        /* Find the variant whose option values match ALL chosen options (null until complete) */
        function resolveVariant() {
          for (var i = 0; i < optGroups.length; i++) {
            var oi = optGroups[i].getAttribute('data-opt-index');
            if (selected[oi] == null || selected[oi] === '') return null;
          }
          for (var k = 0; k < variants.length; k++) {
            var v = variants[k], match = true;
            for (var j = 0; j < optGroups.length; j++) {
              var idx = parseInt(optGroups[j].getAttribute('data-opt-index'), 10);
              if (!v.options || v.options[idx] !== selected[idx]) { match = false; break; }
            }
            if (match) return v;
          }
          return null;
        }

        /* Find a variant matching only the options chosen SO FAR — used to preview the price
           the moment a metal is picked (price is driven by metal; size doesn't change it). */
        function matchPartial() {
          var keys = [];
          for (var oi in selected) {
            if (selected.hasOwnProperty(oi) && selected[oi] !== '' && selected[oi] != null) keys.push(oi);
          }
          if (!keys.length) return null;
          for (var k = 0; k < variants.length; k++) {
            var v = variants[k], ok = true;
            for (var i = 0; i < keys.length; i++) {
              if (!v.options || v.options[parseInt(keys[i], 10)] !== selected[keys[i]]) { ok = false; break; }
            }
            if (ok) return v;
          }
          return null;
        }

        function applyRingSelection() {
          var full = resolveVariant();
          var preview = full || matchPartial();
          /* DISPLAY: price + photo reflect the current selection immediately (even partial) */
          if (priceEl) priceEl.textContent = formatMoney(preview ? preview.price : cardBase);
          if (imgEl) imgEl.src = (preview && preview.image) ? preview.image : baseImg;
          /* The button only unlocks once every option resolves to a real, in-stock variant —
             that is the "choose the size/metal first" rule. */
          btn.textContent = (full && !full.available) ? 'Sold out' : 'Add to Cart';
          btn.disabled = !(full && full.available);
          refreshBundle();
        }

        /* Expose this card's state to the combined "Add both to Cart" button. */
        card._bundleReady   = function() { var f = resolveVariant(); return !!(f && f.available); };
        card._bundleVariant = function() { var f = resolveVariant(); return (f && f.available) ? f.id : null; };
        card._bundlePrice   = function() { var f = resolveVariant() || matchPartial(); return f ? f.price : cardBase; };
        card._bundleFlagMissing = function() {
          var miss = false;
          optGroups.forEach(function(group) {
            var oi = group.getAttribute('data-opt-index');
            if (selected[oi] == null || selected[oi] === '') { group.classList.add('ijc-product__cross-opt--error'); miss = true; }
          });
          var rv = resolveVariant();
          if (!miss && !(rv && rv.available)) miss = true;
          return miss;
        };

        optGroups.forEach(function(group) {
          var idx = parseInt(group.getAttribute('data-opt-index'), 10);
          group.querySelectorAll('.ijc-product__cross-opt-pill').forEach(function(pill) {
            pill.addEventListener('click', function() {
              group.querySelectorAll('.ijc-product__cross-opt-pill').forEach(function(p) { p.classList.remove('ijc-product__cross-opt-pill--active'); });
              pill.classList.add('ijc-product__cross-opt-pill--active');
              group.classList.remove('ijc-product__cross-opt--error');
              selected[idx] = pill.getAttribute('data-value');
              applyRingSelection();
            });
          });
          var selEl = group.querySelector('.ijc-product__cross-opt-select');
          if (selEl) {
            selEl.addEventListener('change', function() {
              group.classList.remove('ijc-product__cross-opt--error');
              selected[idx] = selEl.value;
              applyRingSelection();
            });
          }
        });

        /* Add to Cart on a card with options: only fires once resolveVariant() has a complete,
           in-stock variant (the button is disabled until then). */
        btn.addEventListener('click', function() {
          var full = resolveVariant();
          if (full && full.available) addCrossSellToCart(btn, full.id);
        });

        /* Mirror the MAIN product's metal on this card: show ONLY the matching metal (hide others).
           Two-tone: only match an actual TWO-TONE metal on the item; if the item has none,
           HIDE the whole card from Complete the Look (per request). Display only. */
        card._syncMetal = function(mainName) {
          var twoTone = metalColor(mainName) === 'two-tone';
          var mainFamily = metalFamily(mainName);
          card.style.display = '';   /* reset (may have been hidden on a previous two-tone selection) */
          for (var g = 0; g < optGroups.length; g++) {
            var group = optGroups[g];
            var pills = group.querySelectorAll('.ijc-product__cross-opt-pill');
            if (!pills.length) continue;   /* metal is rendered as pills */
            var optIdx = parseInt(group.getAttribute('data-opt-index'), 10);
            var matched = null;

            if (twoTone) {
              for (var tp = 0; tp < pills.length; tp++) {
                if (metalColor(pills[tp].getAttribute('data-value')) === 'two-tone') { matched = pills[tp]; break; }
              }
              if (!matched) {
                /* no two-tone option on this item -> hide it while two-tone is selected */
                card.style.display = 'none';
                return;
              }
            } else {
              var best = -1;
              for (var p = 0; p < pills.length; p++) {
                var sc = metalScore(mainName, pills[p].getAttribute('data-value'));
                if (sc > best) { best = sc; matched = pills[p]; }
              }
              if (best < 0) matched = null;
              if (!matched && mainFamily) {
                for (var f = 0; f < pills.length; f++) {
                  if (metalFamily(pills[f].getAttribute('data-value')) === mainFamily) { matched = pills[f]; break; }
                }
              }
            }

            if (matched) {
              for (var q = 0; q < pills.length; q++) {
                if (pills[q] === matched) { pills[q].style.display = ''; pills[q].classList.add('ijc-product__cross-opt-pill--active'); }
                else { pills[q].style.display = 'none'; pills[q].classList.remove('ijc-product__cross-opt-pill--active'); }
              }
              group.classList.remove('ijc-product__cross-opt--error');
              selected[optIdx] = matched.getAttribute('data-value');
            } else {
              /* Main metal (colour/family) not offered by this item — hide it from Complete the Look */
              card.style.display = 'none';
              return;
            }
            applyRingSelection();
            return;
          }
          /* No metal PILL group on this card (e.g. it only has a size option) — its metal is fixed
             in the title (e.g. "White Gold Ladies Claddagh Ring"); hide it if that metal doesn't match. */
          var _tt = card.querySelector('.ijc-product__cross-card-name');
          var _ttc = metalColor(_tt ? _tt.textContent : '');
          if ((_ttc === 'white' || _ttc === 'yellow' || _ttc === 'rose' || _ttc === 'two-tone' || _ttc === 'silver' || _ttc === 'platinum') && metalColor(mainName) !== _ttc) {
            card.style.display = 'none';
          }
        };
      } else {
        var nvid = card.getAttribute('data-variant-id');
        /* 2026-08-19: this used to pre-add the item on page load — that is what made the card
           open as "✓ In bundle" without the shopper touching anything. Now it just sits there
           as an offer until clicked. */
        btn.addEventListener('click', function() {
          if (!nvid) return;
          addCrossSellToCart(btn, nvid);
        });

        /* Metal filter for single-metal items (e.g. "Gold Necklace" vs "White Gold Pendant"):
           show only the one whose TITLE metal matches the main ring's metal; hide the rest. */
        var _cardTitleEl = card.querySelector('.ijc-product__cross-card-name');
        var _cardMetal = metalColor(_cardTitleEl ? _cardTitleEl.textContent : '');
        var _cardHasMetal = (_cardMetal === 'white' || _cardMetal === 'yellow' || _cardMetal === 'rose' || _cardMetal === 'two-tone' || _cardMetal === 'silver' || _cardMetal === 'platinum');
        card._syncMetal = function(mainName) {
          card.style.display = (_cardHasMetal && metalColor(mainName) !== _cardMetal) ? 'none' : '';
        };
        card._bundleReady   = function() { return !!nvid; };
        card._bundleVariant = function() { return nvid || null; };
        card._bundlePrice   = function() { return parseInt(card.getAttribute('data-price'), 10) || 0; };
        card._bundleFlagMissing = function() { return false; };
      }
    });

    /* ── Amazon-style "Add both to Cart" footer ───────────────────────────────
       One button adds every checked, in-stock Complete the Look card in a single
       /cart/add.js call, then goes to the cart. A live Total sums the checked cards.
       A checked card that still needs a size/metal is highlighted (not silently
       skipped) and the add is blocked until it is chosen or unchecked. */
    var bundleFooter = document.createElement('div');
    bundleFooter.className = 'ijc-product__cross-bundle';
    bundleFooter.innerHTML =
      '<div class="ijc-product__cross-bundle-total"><span class="ijc-product__cross-bundle-total-label">Total</span><span class="ijc-product__cross-bundle-total-val" id="ijcBundleTotal"></span></div>';
    var bundleBtn = document.createElement('button');
    bundleBtn.type = 'button';
    bundleBtn.className = 'ijc-product__cross-bundle-add';
    bundleBtn.textContent = 'Add both to Cart';
    bundleFooter.appendChild(bundleBtn);
    wrap.appendChild(bundleFooter);
    var bundleTotalEl = bundleFooter.querySelector('#ijcBundleTotal');
    var btnEl = bundleBtn;   /* alias read by refreshBundle */

    function visibleCards() {
      return Array.prototype.slice.call(wrap.querySelectorAll('.ijc-product__cross-card'))
        .filter(function(c) { return c.style.display !== 'none'; });
    }

    /* ── The viewed product is the anchor of the bundle: "Add both" = this product + the
       checked Complete the Look items, added together (Amazon "frequently bought together"). ── */
    function mainProductReady() {
      var b = I('ijcAddToCart');
      return b ? !b.disabled : true;   /* main Add to Cart is disabled until size/metal is chosen */
    }
    function mainProductPrice() {
      var vi = I('ijcVariantId');
      var id = vi ? parseInt(vi.value, 10) : parseInt(currentVariantId, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i].price;
      }
      return 0;
    }
    function mainProductItem() {
      var vi = I('ijcVariantId');
      var id = vi ? vi.value : currentVariantId;
      if (!id) return null;
      var qtyInput = I('ijcQtyInput');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      /* Carry the same line-item properties the main Add to Cart sends (birthstone months,
         family crest name) so a personalised piece is added correctly, not as a bare variant. */
      var props = {};
      var dropContainer = I('ijcBirthstoneDropdowns');
      if (dropContainer) {
        Array.prototype.slice.call(dropContainer.querySelectorAll('[data-group-index]:not([data-ijc-hidden]) select')).forEach(function(sel) {
          if (sel.name && sel.value) {
            var m = sel.name.match(/^properties\[(.+)\]$/);
            if (m) props[m[1]] = sel.value;
          }
        });
      }
      var crestEl = I('ijcCrestName');
      if (crestEl && crestEl.value.trim()) props['Family Name'] = crestEl.value.trim();
      var item = { id: parseInt(id, 10), quantity: qty };
      if (Object.keys(props).length) item.properties = props;
      return item;
    }

    /* Recompute the Total + button label. The viewed product always counts (count starts at 1);
       the checked Complete the Look cards add on top. */
    function refreshBundle() {
      if (!btnEl) return;
      var cards = visibleCards();
      var count = 1;
      var total = mainProductPrice();
      cards.forEach(function(c) {
        var on = c._bundleCheckbox ? c._bundleCheckbox.checked : true;
        if (!on) return;
        count++;
        total += (c._bundlePrice ? c._bundlePrice() : 0);
      });
      if (bundleTotalEl) bundleTotalEl.textContent = formatMoney(total);
      btnEl.disabled = false;
      btnEl.textContent = count === 1 ? 'Add to Cart'
        : (count === 2 ? 'Add both to Cart' : 'Add all ' + count + ' to Cart');
    }

    bundleBtn.addEventListener('click', function() {
      if (bundleBtn.disabled) return;

      /* The viewed product is always part of the bundle. If it still needs a size/metal, the
         main Add to Cart is disabled — send the shopper up to choose it before adding. */
      if (!mainProductReady()) {
        var mainBtn = I('ijcAddToCart');
        if (mainBtn) mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var items = [];
      var main = mainProductItem();
      if (main) items.push(main);

      var cards = visibleCards(), firstBlocked = null;
      cards.forEach(function(c) {
        var on = c._bundleCheckbox ? c._bundleCheckbox.checked : true;
        if (!on) return;
        if (c._bundleReady && c._bundleReady()) {
          items.push({ id: parseInt(c._bundleVariant(), 10), quantity: 1 });
        } else {
          if (c._bundleFlagMissing) c._bundleFlagMissing();
          if (!firstBlocked) firstBlocked = c;
        }
      });
      if (firstBlocked) {
        firstBlocked.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      if (!items.length) return;

      bundleBtn.disabled = true;
      bundleBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r) {
        if (!r.ok) throw new Error('cart error');
        window.location.href = '/cart';
      }).catch(function() {
        bundleBtn.disabled = false;
        refreshBundle();
        alert('Sorry, there was a problem adding these items. Please try again.');
      });
    });

    refreshBundle();   /* initial Total + label */

    /* Mirror the main product's metal onto the cross-sell cards — on load and whenever it changes */
    document.addEventListener('click', function(e) {
      if (e.target.closest('.ijc-product__option-btn')) setTimeout(syncCrossSellMetal, 0);
    });
    document.addEventListener('change', function(e) {
      if (e.target.closest('.ijc-product__option-group')) setTimeout(syncCrossSellMetal, 0);
    });
    syncCrossSellMetal();
  }

  document.addEventListener('DOMContentLoaded', function() {
    setDeliveryDates();
    initGallery();
    initVideoGallery();
    initVariants();
    initQuantity();
    initAccordions();
    initSizeGuide();
    initRingValidation();
    initCrossSell();
    initHelpPopup();
    initSmoothScroll();
    initActions();
    if (C.isSingleBirthstone) initSingleBirthstone();
    else if (C.isBirthstone) initBirthstone();
  });

})();
